const EmailTemplate = ({ senderName = "Frederik" }) => {
  return (
    <div className="max-w-xl w-auto mx-auto bg-white shadow-lg rounded-lg p-12 m-4">
      <div className="flex justify-self-center mb-16">
        <img
          src={"/images/new_contimo_small.png"}
          alt="Brand Art"
          className="flex w-32 h-8 justify-self-center"
        />
      </div>
      <h1 className="text-2xl font-bold mb-4">
        {senderName} has invited you to join Contimo!
      </h1>
      <p className="text-gray-700 mb-4">
        By using Contimo, you'll have access to a suite of powerful tools for
        creating and optimizing native ad campaigns. Plus, you'll be able to
        collaborate with your colleagues and track your results in real-time.
      </p>
      <p className="text-gray-700 mb-4">
        Don't miss out on this opportunity to take your native advertising to
        the next level.
      </p>
      <button className="px-4 py-2 mt-8 font-bold text-white bg-blue-500 rounded-full hover:bg-blue-700 focus:outline-none focus:shadow-outline-blue active:bg-blue-800">
        Join now
      </button>
    </div>
  );
};

export default EmailTemplate;
